import { CheckCircleOutlined } from '@ant-design/icons';
import {
  Popconfirm, Popover, Typography,
} from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAcceptRecruitmentRequest } from 'src/gql/mutations/recruitment';
import { RecruitmentBoarderRequest } from 'src/shared/types/api';
import { RecruitmentEventEnum } from 'src/shared/types/docs';

type AcceptRecruitmentButtonProps = {
  record: RecruitmentBoarderRequest;
}

export const AcceptRecruitmentButton = ({ record }: AcceptRecruitmentButtonProps) => {
  const { t } = useTranslation();
  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [disabled, setDisabled] = useState(record.events.some(
    ({ event }) => event === RecruitmentEventEnum.REQUEST_ACCEPTED,
  ));

  const [
    acceptRecruitmentRequest,
    loading,
  ] = useAcceptRecruitmentRequest({
    boarderRecruitmentId: record.boarderRecruitmentId,
    onSuccess: () => setDisabled(true),
    onComplete: () => setPopConfirmVisible(false),
  });

  return (
    <Popconfirm
      title={t('Confirm accept recruitment request')}
      okText={t('Yes')}
      visible={popConfirmVisible}
      onConfirm={acceptRecruitmentRequest}
      okButtonProps={{ loading }}
      onCancel={() => setPopConfirmVisible(false)}
    >
      <Popover content={t('Accept recruitment request')}>
        <Typography.Link disabled={disabled}>
          <CheckCircleOutlined onClick={() => setPopConfirmVisible(true)} />
        </Typography.Link>
      </Popover>
    </Popconfirm>
  );
};
